// extracted by mini-css-extract-plugin
export default {"cancelLink":"iP-z"};